// extracted by mini-css-extract-plugin
export default {"root":"RoleAppMenu_root__vaehj","top":"RoleAppMenu_top__tcEUD","middle":"RoleAppMenu_middle__q2ZIK","bottom":"RoleAppMenu_bottom__WML-I"};